
import React from 'react';
import './Siliconapplicans.css';
import BJMSeries from '../../../imgs/Siliconappli.webp'; 

const Siliconapplicans = () => {
  return (
    <div className="Silic-container" data-aos="fade-down">
      <img src={BJMSeries} alt="Fitting Corrosion" className="Silic-image" />
    </div>
  );
};

export default Siliconapplicans;
